import React from 'react';
import styled from 'styled-components';
import GridContainer from './GridContainer';
import GridRow from './GridRow';
import ArrowDown from '../../assets/img/arrowDown.svg';
import { colors } from '../theme/ColorTheme';
import Radio from './radio';
import { connect } from 'react-redux';
import * as Selectors from '../store/selectors';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import Installationssystem from './Infotemplates/Installationssystem';
import Wandtyp from './Infotemplates/Wandtyp';
import { GradientElement } from 'canvg';
import InfoBox from './InfoBox';

class Wandsystem extends React.Component {
    constructor(props) {
        super(props);
        this.resetChoices = this.resetChoices.bind(this);
    }

    resetChoices(event){
        var patt=/["][a-z_]+/i;
        var wert1=document.getElementById("selectWandaufbau").innerHTML.match(patt);
        wert1=wert1[0].replace("\"","");
        if(document.getElementById("selectSteinsorte")!=null){
        var wert2=document.getElementById("selectSteinsorte").innerHTML.match(patt);
        wert2=wert2[0].replace("\"","");
        document.getElementById("selectSteinsorte").value=wert2;}
        document.getElementById("selectWandaufbau").value=wert1;
       
    }

    render() {
        const {
            heading,
            installationssystem,
            wandaufbau,
            steinsorte,
            wandstaerke,
            putz,
            korrekturWerte,
            setInstallationssystemChoice,
            setWandaufbauChoice,
            setSteinsorteChoice,
            setWandstaerkeChoice,
            setPutzChoice,
            isPutzEnabled,
            intl,
            steinsorteActive,
         
        } = this.props;
        
       
        return (
            <GridContainer heading={heading}>
                {installationssystem.length > 0 && (
                    <GridRow 
                        hasInfoBox={true}  
                        infoBoxContent={<Installationssystem />} 
                        infoBoxHeadline={
                            <FormattedHTMLMessage id="Installationssystem_Headline" />}

                        label={<FormattedHTMLMessage 
                        id="installations-system-label" 
                        />}>
                        <StyledSelect onChange={this.resetChoices} >
                            <Select onChange={e => setInstallationssystemChoice(e.target.value)}>
                                {installationssystem.map(item => (
                                    <option key={item.value} value={item.value}>
                                        {item.label}
                                    </option>
                                  
                                )) } 
                                
                            </Select>
                            <GradientRect/>
                           <StyledImg src={ArrowDown} />
                        </StyledSelect>
                    </GridRow>
                )}
                {wandaufbau.length > 0 && (
                    <GridRow label={<FormattedHTMLMessage id="wandaufbau-label" />}>
                        <StyledSelect>
                            <Select id="selectWandaufbau" onChange={e => setWandaufbauChoice(e.target.value)}>
                                {wandaufbau.map(item => (
                                    <option key={item.value} value={item.value}>
                                        {intl.formatMessage({ id: item.label })}
                                    </option>
                                    
                                ))}
                            </Select>
                            <GradientRect/>
                           <StyledImg src={ArrowDown} />
                
                        </StyledSelect>
             
                    </GridRow>
                )}
                {steinsorte.length > 0 && (
                    <GridRow 
                    hasInfoBox={true}  
                    infoBoxContent={<Wandtyp />} 
                    infoBoxHeadline={<FormattedHTMLMessage 
                        id="Wandtyp_Headline" />}

                    label={<FormattedHTMLMessage 
                    id="steinsorte-label" />}>
                        <StyledSelect>
                            <Select  id="selectSteinsorte" onChange={e => setSteinsorteChoice(e.target.value)}>
                                {steinsorte.map(item => (
                                    <option key={item.value} value={item.value}>
                                        {intl.formatMessage({ id: item.label })}
                                    </option>
                                )) }
                            </Select>
                            <GradientRect/>
                           <StyledImg src={ArrowDown} />
                        </StyledSelect>
                    </GridRow>
                )}
                {wandstaerke.length > 0 && (
                    <GridRow 
                        hasInfoBox={true} 
                        infoBoxContent={<Wandtyp />} 
                  
                        label={<FormattedHTMLMessage 
                        id="wandstaerke-label" />}>
                        <StyledSelect>
                            <Select  onChange={e => setWandstaerkeChoice(e.target.value)}>
                                {wandstaerke.map(item => (
                                    <option key={item.value} value={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                            </Select>
                            <GradientRect/>
                           <StyledImg src={ArrowDown} />
                        
                        </StyledSelect>
                    </GridRow>
                )}
                {steinsorteActive != "lochsteine"&&steinsorteActive != "basiswand_geberit"&&isPutzEnabled && (
                 
                    <RadioGroup>                        
                        <GridRow  label={<FormattedHTMLMessage id="is-putz-enabled-label" />}>
                            <RadioButtons>
                                <Radio setValue={value => setPutzChoice(value)} value={putz} />
                            </RadioButtons>
                        </GridRow>
                    </RadioGroup>

                )}
                {wandstaerke.length > 0 && (
                    <GridRow label={<FormattedHTMLMessage id="flaechengewicht-label-headline" />}>
                        {korrekturWerte.flaechengewicht} kg/m²
                    </GridRow>
                )}    
           
            </GridContainer>
           
        );
    }
}

const mapStateToProps = state => ({
    wandaufbau: Selectors.getWandaufbauChoices(state),
    steinsorte: Selectors.getSteinsorteChoices(state),
    wandstaerke: Selectors.getWandstaerkeChoices(state),
    installationssystem: Selectors.getInstallationssystemChoices(state),
    putz: state.choices.putz,
    isPutzEnabled: Selectors.isPutzEnabled(state),
    korrekturWerte: Selectors.getKorrekturWerte(state),
    steinsorteActive: state.choices.steinsorte,
   
});

const mapDispatchToProps = dispatch => ({
    setInstallationssystemChoice: value => dispatch({ type: 'SET_CHOICE__INSTALLATIONSSYSTEM', value }),
    setWandaufbauChoice: value => dispatch({ type: 'SET_CHOICE__WANDAUFFBAU', value }),
    setSteinsorteChoice: value => dispatch({ type: 'SET_CHOICE__STEINSORTE', value }),
    setWandstaerkeChoice: value => dispatch({ type: 'SET_CHOICE__WANDSTAERKE', value }),
    setPutzChoice: value => dispatch({ type: 'SET_CHOICE__PUTZ', value }),
});

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Wandsystem)
);

const RadioButtons = styled.form`
    display: flex;
    align-items: center;
`;

const StyledSelect = styled.div`
    width: 100%;
    height: 46px;
    border: solid 1px ${colors.borderColor};
    display: inline-block;
    position: relative;
    img {
        position: absolute;
        right: 23.3px;
        top: 19.6px;
        z-index:6;
    }
`;

const Select = styled.select`
    cursor: pointer;
    font-size: 1rem;
    background: transparent;
    outline: none;
    -webkit-appearance: none;
    padding: 0 1.5rem;
    border: none;
    width: 100%;
    height: 46px;
    overflow: hidden;
    text-overflow: ellipsis;
    ::-ms-expand {
        display: none;
    }
`;

const RadioGroup = styled.div`
    margin-top: 27px;
    margin-bottom: 27px;
`;
const GradientRect= styled.div`
height:42px;
width:200px;
float:right;
position:relative;
top:-45px;
right:0.2px;
pointer-events: none;
background-image: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1));
`;

const StyledImg = styled.img`
pointer-events: none;
`;